import Img2023_1 from '../img/jury/data4 img2023_1.jpg'
import Img2023_2 from '../img/jury/data4 img2023_2.jpg'
import Img2023_3 from '../img/jury/data4 img2023_3.jpg'
import Img2022_1 from '../img/jury/data4 img2022_1.jpeg'
import Img2022_2 from '../img/jury/data4 img2022_2.jpg'
import Img2022_3 from '../img/jury/data4 img2022_3.jpeg'
import Img2021_1 from '../img/jury/data4 img2021_1.jpg'

const data4 = [
    {
      year: 2023,
      items: [
        {
          name: 'АННА ПЛАТОНЕНКО',
          country: 'Россия',
          image: Img2023_1,
          text1: 'Руководитель Комиссии по эстетической медицине в «ОПОРЕ РОССИИ»',
          text2: 'Основатель и руководитель медицинского центра HB cosmetology center',
          text3: 'Основатель благотворительной деятельности «Добрый понедельник»',
          text4: 'Автор рубрики CosmoЗОЖ в журнале SiberianLife',
          text5: 'Опыт работы более 10 лет',
        },
        {
            name: 'НАТАЛЬЯ КОШЕЛЕВА',
            country: 'Украина',
          image: Img2023_2,
          text1: 'Основатель Международной Академии Косметологии',
          text2: 'Обучила более 400 успешных тренеров в косметологии в РФ, ближнем зарубежье, Европе, ОАЭ и США',
          text3: 'Создала курс MBI',
          text4: 'Менеджмент в управлении медицинским центром',
          text5: 'Автор курсов «Франшиза – это просто»,«Тренер в косметологии»',
        },
        {
            name: 'СВЕТЛАНА ШИТИКОВА',
            country: 'Россия',
          image: Img2023_3,
          text1: 'Учредитель холдинга LADYLAND',
          text2: 'Автор и создатель бренда LESSEL',
          text3: 'Член Комитета по здравоохранению и Комиссии по эстетической медицины НОО «ОПОРА РОССИИ»',
          text4: 'Обучила более 700 успешных тренеров в косметологии',
          text5: 'Опыт работы более 25 лет',
        },
      ],
    },
    {
        year: 2022,
        items: [
          {
            name: 'АЛЕКСАНДР ИГУМНОВ',
            country: 'Украина',
            image: Img2022_1,
            text1: 'Врач-хирург, врач пластический хирург',
            text2: 'Врач-косметолог в клинике Центр пластической хирургии и косметологии "Шарм"',
            text3: 'Автор новых методик в косметологии и пластической хирургии',
            text4: 'Имеет собственные патенты по методикам в косметологии и пластической хирургии',
            text5: 'Опыт работы более 15 лет',
          },
          {
            name: 'ИРИНА ОВДИНА',
            country: 'Россия',
            image: Img2022_2,
            text1: 'Автор и организатор Чемпионата косметологов Сибири',
            text2: 'Генеральный директор ММА Мёд',
            text3: 'Медицинский маркетолог, медицинский продюсер, руководитель продюсерского центра медсобытий «ПРЕЗА»',
            text4: 'Старший преподаватель НГПУ, преподаватель практик НГУЭУ',
            text5: 'Замруководителя по связам с общественностью Комитета по здравоохранению НОО «ОПОРА РОССИИ»',
          },
          {
            name: 'НАТАЛЬЯ БОГОМЯГКОВА',
            country: 'Россия',
            image: Img2022_3,
            text1: 'Эксперт рынка косметологии',
            text2: 'Врач-косметолог, сертифицированный тренер Lady Land',
            text3: 'Автор и организатор Чемпионатов',
            text4: 'Обучила более 350 успешных тренеров в косметологии',
            text5: 'Опыт работы более 20 лет',
          },
        ],
      },
      {
        year: 2021,
        items: [
          {
            name: 'ЕЛЕНА ХОДЫКИНА',
            country: 'Украина',
            image: Img2021_1,
            text1: 'Эксперт в области превентивной медицины',
            text2: 'Врач-терапевт, диетолог-нутрициолог, превентолог',
            text3: 'Директор МЦ «5П МЕДИЦИНА»',
            text4: 'Кандидат медицинских наук',
            text5: 'Опыт работы более 10 лет',
        },
          {
            name: 'НАТАЛЬЯ КОШЕЛЕВА',
            country: 'Украина',
          image: Img2023_2,
          text1: 'Основатель Международной Академии Косметологии',
          text2: 'Обучила более 400 успешных тренеров в косметологии в РФ, ближнем зарубежье, Европе, ОАЭ и США',
          text3: 'Создала курс MBI',
          text4: 'Менеджмент в управлении медицинским центром',
          text5: 'Автор курсов «Франшиза – это просто»,«Тренер в косметологии»',
          },
          {
            name: 'СВЕТЛАНА ШИТИКОВА',
            country: 'Россия',
          image: Img2023_3,
          text1: 'Учредитель холдинга LADYLAND',
          text2: 'Автор и создатель бренда LESSEL',
          text3: 'Член Комитета по здравоохранению и Комиссии по эстетической медицины НОО «ОПОРА РОССИИ»',
          text4: 'Обучила более 700 успешных тренеров в косметологии',
          text5: 'Опыт работы более 25 лет',
          },
        ],
      },
      {
        year: 2020,
        items: [
          {
            name: 'АННА ПЛАТОНЕНКО',
            country: 'Россия',
            image: Img2023_1,
            text1: 'Руководитель Комиссии по эстетической медицине в «ОПОРЕ РОССИИ»',
            text2: 'Основатель и руководитель медицинского центра HB cosmetology center',
            text3: 'Основатель благотворительной деятельности «Добрый понедельник»',
            text4: 'Автор рубрики CosmoЗОЖ в журнале SiberianLife',
            text5: 'Опыт работы более 10 лет',
          },
          {
            name: 'ИРИНА ОВДИНА',
            country: 'Россия',
            image: Img2022_2,
            text1: 'Автор и организатор Чемпионата косметологов Сибири',
            text2: 'Генеральный директор ММА Мёд',
            text3: 'Медицинский маркетолог, медицинский продюсер, руководитель продюсерского центра медсобытий «ПРЕЗА»',
            text4: 'Старший преподаватель НГПУ, преподаватель практик НГУЭУ',
            text5: 'Замруководителя по связам с общественностью Комитета по здравоохранению НОО «ОПОРА РОССИИ»',
          },
          {
            name: 'НАТАЛЬЯ БОГОМЯГКОВА',
            country: 'Россия',
            image: Img2022_3,
            text1: 'Эксперт рынка косметологии',
            text2: 'Врач-косметолог, сертифицированный тренер Lady Land',
            text3: 'Автор и организатор Чемпионатов',
            text4: 'Обучила более 350 успешных тренеров в косметологии',
            text5: 'Опыт работы более 20 лет',
          },
        ],
      },
      {
        year: 2019,
        items: [
          {
            name: 'ЕЛЕНА ХОДЫКИНА',
            country: 'Украина',
            image: Img2021_1,
            text1: 'Эксперт в области превентивной медицины',
            text2: 'Врач-терапевт, диетолог-нутрициолог, превентолог',
            text3: 'Директор МЦ «5П МЕДИЦИНА»',
            text4: 'Кандидат медицинских наук',
            text5: 'Опыт работы более 10 лет',
          },
          {
            name: 'АЛЕКСАНДР ИГУМНОВ',
            country: 'Украина',
            image: Img2022_1,
            text1: 'Врач-хирург, врач пластический хирург',
            text2: 'Врач-косметолог в клинике Центр пластической хирургии и косметологии "Шарм"',
            text3: 'Автор новых методик в косметологии и пластической хирургии',
            text4: 'Имеет собственные патенты по методикам в косметологии и пластической хирургии',
            text5: 'Опыт работы более 15 лет',
          },
          {
            name: 'АННА ПЛАТОНЕНКО',
            country: 'Россия',
            image: Img2023_1,
            text1: 'Руководитель Комиссии по эстетической медицине в «ОПОРЕ РОССИИ»',
            text2: 'Основатель и руководитель медицинского центра HB cosmetology center',
            text3: 'Основатель благотворительной деятельности «Добрый понедельник»',
            text4: 'Автор рубрики CosmoЗОЖ в журнале SiberianLife',
            text5: 'Опыт работы более 10 лет',
          },
        ],
      },
  ];

  export default data4;
